import React, { useEffect, useState } from 'react';
import { queueService } from '../services/api';

const AdminQueueHealth = ({ user }) => {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true); setError('');
    try {
      const data = await queueService.health();
      setHealth(data);
    } catch (e) {
      console.error(e);
      setError(e.response?.data?.error || 'Chyba pri načítaní stavu fronty');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  if (!user || user.role !== 'admin') return <div style={{ padding:20 }}>Prístup zamietnutý</div>;

  return (
    <div style={{ padding:20 }}>
      <h1>🧰 Queue Health</h1>
      <div style={{ display:'flex', gap:10, marginBottom:12 }}>
        <button onClick={load} disabled={loading}>Obnoviť</button>
        <button onClick={async ()=>{ await queueService.triggerMonthlyReports(); alert('Job enqueue-nutý'); load(); }} disabled={loading}>Spustiť mesačné reporty</button>
      </div>
      {error && <div style={{ color:'red', marginBottom:10 }}>{error}</div>}
      {health ? (
        <div style={{ border:'1px solid #ddd', padding:12, borderRadius:6 }}>
          <div><strong>Queue:</strong> {health.queue}</div>
          <div><strong>Repeat Scheduled:</strong> {String(health.repeatScheduled)}</div>
          <div style={{ marginTop:10 }}>
            <strong>Counts:</strong>
            <ul>
              {Object.entries(health.counts || {}).map(([k,v]) => (
                <li key={k}>{k}: {v}</li>
              ))}
            </ul>
          </div>
        </div>
      ) : (
        <div>Načítavam...</div>
      )}
    </div>
  );
};

export default AdminQueueHealth;
